import { render, staticRenderFns } from "./PressNewsCard.vue?vue&type=template&id=4f7bb1e2&scoped=true&"
import script from "./PressNewsCard.vue?vue&type=script&lang=js&"
export * from "./PressNewsCard.vue?vue&type=script&lang=js&"
import style0 from "./PressNewsCard.vue?vue&type=style&index=0&id=4f7bb1e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7bb1e2",
  null
  
)

export default component.exports